(function () {
  'use strict';

  function initTrustBadges() {
    document.querySelectorAll('.trust-badges-v2').forEach(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrustBadges);
  } else {
    initTrustBadges();
  }

  document.addEventListener('shopify:section:load', initTrustBadges);
})();